import { render, staticRenderFns } from "./zhihuichengshi.vue?vue&type=template&id=a725e2ba&scoped=true&"
import script from "./zhihuichengshi.vue?vue&type=script&lang=js&"
export * from "./zhihuichengshi.vue?vue&type=script&lang=js&"
import style0 from "./zhihuichengshi.vue?vue&type=style&index=0&id=a725e2ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a725e2ba",
  null
  
)

export default component.exports